import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

// Auth page title
export const AuthPageTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.main,
  fontWeight: 600,
  textAlign: 'center',
  fontSize: '1.75rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
  },
}));

// Auth subtitle/description
export const AuthSubtitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontSize: '1rem',
  lineHeight: 1.5,
}));

// Auth error message
export const AuthErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  textAlign: 'center',
  marginBottom: theme.spacing(2),
  fontSize: '0.875rem',
}));

// Auth success message
export const AuthSuccessMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.success.main,
  textAlign: 'center',
  marginBottom: theme.spacing(2),
  fontSize: '0.875rem',
}));

// Auth navigation link
export const AuthNavLink = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  fontSize: '0.875rem',
  '&:hover': {
    color: theme.palette.primary.dark,
    textDecoration: 'underline',
  },
})); 